module.exports = __webpack_public_path__ + "static/media/coffee_desktop_en.78462477.jpg";